<template>
  <div class="new-user">
    <a-button type="primary" size="large" @click="showModal">
      Add Account
    </a-button>
    <a-modal
      okText="Create"
      title="Create New Account"
      destroyOnClose


      :visible="visible"
      :confirm-loading="confirmLoading"

      @ok="handleOk"
      @cancel="handleCancel"
    >
    
    <registration-form 
      ref="form"
      @submit="onSubmit"
    />
    
    </a-modal>
  </div>
</template>

<script>

import registrationForm from '@/components/administration/registration_form.vue'
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
    };
  },
  components: {
    registrationForm
  },
  methods: {

    ...mapActions('users',['createUser']),

    showModal() {
      this.visible = true;
    },

    async onSubmit(data){
      this.confirmLoading = true;
      await this.createUser(data)
      this.visible = false;
      this.confirmLoading = false;
      
    },

    handleOk(e) {
      this.$refs.form.handleSubmit();
    },

    handleCancel(e) {
      this.visible = false;
    },
    
  },
};
</script>

<style lang="scss" scoped>
.new-user{
  margin-bottom: 16px;
}
</style>